<p-panel>
    <ng-container *ngIf="isReactiveFormReady; else reactiveFormLoadingState">
        <app-reactive-form-builder
            (goBack)="goBack()"
            (internalLifecycleEvents)="onReactiveFormLifecycleEvent($event)"
            (stableValueChanges)="stableValueChanges($event)"
            [form]="form.formFields"
            [getRequest]="tareasApi.bio.GET"
            [id]="reactiveFormRecordId"
            [previousData]="initialPreviousData"
            [request]="request"
            [serverUrl]="env.serverUrl">
            <button
                slot="extra-buttons"
                *ngIf="env.showGenerateRecetaBio"
                class="btn btn-warning mx-2"
                type="button"
                (click)="generarReceta()">
                Generar Receta
            </button>
        </app-reactive-form-builder>
    </ng-container>
</p-panel>

<ng-template #reactiveFormLoadingState>
    <div class="p-3 text-center" role="status" aria-live="polite">
        <div *ngIf="!reactiveFormLoadingError" class="text-muted">
            Preparando formulario bio...
        </div>
        <div *ngIf="reactiveFormLoadingError" class="alert alert-danger mb-0" role="alert">
            {{ reactiveFormLoadingError }}
        </div>
    </div>
</ng-template>

<p-dialog header="Generar receta" [(visible)]="showRecetaTareaBio">
    <div id="html2canvasDiv" class="registroDiv">
        <div class="d-flex mb-5" style="font-size: 0.7rem; height: 100px;">
            <div style="flex: 1" class="d-flex flex-column justify-content-between">
                <span style="font-weight: bold; text-decoration: underline; font-size: 0.85rem;">
                    TAREA BIO
                    <img [src]="env.logoUrl" style="width: 80px; height: auto; display: block;" alt="" />
                </span>
                <span>CENTRO: {{receta.finca_nombre}}</span>
                <span>SUBPARCELA(S):
                    <span> {{ receta.parcela }}</span>
                </span>
                <span>PH Caldo: {{receta.ph_caldo}} - PH Agua: {{receta.ph_agua}} - PH Final: {{receta.ph_final}}</span>
                <span>
                    {{receta.fecha_receta}}
                </span>
            </div>
        </div>

        <div class="ml-2 mb-2" *ngIf="env.appName !== 'hernandorena'">
            Nivel de peligrosidad: <b>{{receta.nivel_peligrosidad}}</b>
        </div>

        <table class="w-100 table-bordered table-hernandorena">
            <thead class="text-center" style="font-size: 0.7rem;">
                <th class="p-1">MARCA COMERCIAL</th>
                <th class="p-1">DOSIS (cc o g/100L)</th>
                <th class="p-1">ORG. COMBATIR</th>
            </thead>
            <tbody>
                <tr>
                    <td class="p-3">{{ receta.producto }}</td>
                    <td class="p-3">{{ receta.dosis }}</td>
                    <td class="p-3">{{ receta.tipo_plaga }}</td>
                </tr>
            </tbody>
        </table>

        <div class="d-flex justify-content-between mt-2" style="font-size: 0.7rem;">
            <span style="flex: 3">Ordenante: firma y fecha</span>
            <span style="flex: 2">Realizador: firma y fecha</span>
        </div>
    </div>

    <div class="mt-4 d-flex justify-content-center">
        <button class="btn btn-dark mx-2" [disabled]="isGeneratingCanvas" type="button" (click)="showRecetaTareaBio = false">Cerrar</button>
        <button class="btn btn-primary mx-2" [disabled]="isGeneratingCanvas" type="button" (click)="imprimirReceta();">
            {{isGeneratingCanvas ? 'Generando PDF...' : 'Imprimir'}}
        </button>
    </div>
    <br>
</p-dialog>
